'use client';

import { ResumeDownloadEffect } from '@/components/download/ResumeDownloadEffect';
import { CustomToaster } from '@/components/ui/custom-toaster';
import { AuthProvider } from '@/contexts/AuthContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

type Props = {
  children: ReactNode;
};

export function Providers({ children }: Props) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: Infinity,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {children}
        <ResumeDownloadEffect />
        <CustomToaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
